<template>
  <div class="querybychoice">
    <div v-html="message"></div>
    <br/>
    <div class="vueforms-dialog-buttons-bottom">
      <template v-for="(choice) in buttons">
        <hy-button class="choicebutton" @click="resolve(choice[1])">{{choice[0]}}</hy-button>
      </template>
    </div>
  </div>
</template>

<script>
import HyButton from '../../basic-components/HyButton.vue'


export default {
  props: {
    resolve: Function,
    message: String,
    choices: {
      type: Array,
      default() { return [["Ja", true], ["Nein", false]] }
    }
  },
  components: {
    HyButton
  },
  inheritAttrs: false,
  setup(props) {
    let buttons = props.choices.map(e => {
      if (e instanceof Array) {
        return e
      }
      else {
        return [e, e]
      }
    })
    return {
      buttons
    }
  }
}
</script>

<style>

</style>